export const SEARCH_STRING_MICROFRONTEND_NAME = 'search-string-micro-frontend';
